class AccordionDetailsDrawer extends DrawerComponent {
    constructor() {
        super();
    }

    show(focusElement = null, animate = true) {
        super.show(focusElement, animate);

        if (this.open) {
            FoxTheme.a11y.trapFocus(this, this.focusElement);
        }
    }
}

customElements.define('accordion-details-drawer', AccordionDetailsDrawer);

document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-content-drawer-trigger]');
    if (!trigger) return;

    const id = trigger.getAttribute('aria-controls');
    const drawer = document.getElementById(id);

    if (drawer && typeof drawer.show === 'function') {
        drawer.show(trigger, true);
        trigger.setAttribute('aria-expanded', 'true');
    }
});